import call from "../../../api/call";
import type { ProjectRole } from "../../../api/useUser";

const updateProjectRole = (
  userProfilId: string,
  projectId: string,
  projectRole: ProjectRole | null,
) =>
  call("POST", "/users/:userId(uuid)/roles/projects/:projectId(uuid)", {
    body: { role: projectRole },
    routeParams: {
      projectId,
      userId: userProfilId,
    },
  });

export default updateProjectRole;
